import { Link } from "react-router-dom";
import "./Footer.css";

function Footer() {

  /* Scroll Top Function */

  const scrollToTop = () => {

    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });

  };

  return (

    <footer className="footer">

      {/* Background Effects */}

      <div className="footer-glow glow-1"></div>
      <div className="footer-glow glow-2"></div>

      {/* Footer Container */}

      <div className="footer-container">

        {/* Company Info */}

        <div className="footer-box">

          <h1>Chennai Washcare</h1>

          <p>
            Trusted multi brand washing machine service center in Chennai
            offering fast doorstep repair and maintenance services for all
            major washing machine brands.
          </p>

        </div>

        {/* Quick Links */}

        <div className="footer-box">

          <h2>Quick Links</h2>

          <ul>

            <li>
              <Link to="/" onClick={scrollToTop}>
                Home
              </Link>
            </li>

            <li>
              <Link to="/about" onClick={scrollToTop}>
                About Us
              </Link>
            </li>

            <li>
              <Link
                to="/washing-machine-service"
                onClick={scrollToTop}
              >
                Washing Machine Service
              </Link>
            </li>

            <li>
              <Link to="/contact" onClick={scrollToTop}>
                Contact
              </Link>
            </li>

          </ul>

        </div>

        {/* Contact Info */}

        <div className="footer-box">

          <h2>Address</h2>

          <p>
            📍 D/O. Rajasekaran, 22/A/28A,
            Vivekananda Colony 1st Street,
            Saidapet, Chennai,
            Tamil Nadu - 600015
          </p>

          <p>
            📞+91 9790066906
          </p>

          <p>
            ✉️ chennaiwashcare210@gmail.com
          </p>

        </div>

      </div>

      {/* Footer Bottom */}

      <div className="footer-bottom">

        <p>
          ©2026 Chennai Washcare. All Rights Reserved.
        </p>

        {/* Bottom Links */}

        <div className="footer-bottom-links">

          <Link
            to="/privacy-policy"
            onClick={scrollToTop}
          >
            Privacy Policy
          </Link>

          <Link
            to="/terms-and-conditions"
            onClick={scrollToTop}
          >
            Terms & Conditions
          </Link>

        </div>

      </div>

    </footer>

  );

}

export default Footer;